<template>
  <div id="featured-projects">
    <div class="shadow-cont"></div>
    <div class="section-header">
      <h2>Featured Projects</h2>
    </div>

    <div class="projects-container">
      <div class="project web-project">
        <div class="project-content">
          <img
            src="../assets/images/featured-projects/radio-recliner-work.jpg"
          />
          <div class="project-hover">
            <h4>Radio Recliner <br />Web Radio Station</h4>

            <ModalRadioRecliner />
          </div>
        </div>
      </div>

      <div class="project web-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/CDI.jpg" />
          <div class="project-hover">
            <h4>Ceramic Dental Implants <br />Website</h4>

            <ModalCeramicDental />
          </div>
        </div>
      </div>

      <div class="project web-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/aie-training.jpg" />
          <div class="project-hover">
            <h4>AIE Dental Implant <br />Training Website</h4>

            <ModalAIE />
          </div>
        </div>
      </div>

      <div class="project web-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/Circuit-Studios.jpg" />
          <div class="project-hover">
            <h4>Circuit Studios <br />Website</h4>
            <ModalCircuitStudios />
          </div>
        </div>
      </div>

      <div class="project web-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/SDP-responsive.jpg" />
          <div class="project-hover">
            <h4>Superior Dealer Products Website</h4>
            <ModalSDP />
          </div>
        </div>
      </div>

      <div class="project web-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/GripWorksCo.jpg" />
          <div class="project-hover">
            <h4>GripWorks Colorado</h4>
            <ModalGripWorks />
          </div>
        </div>
      </div>

      <div class="project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/MeterMiser-Main.jpg" />
          <div class="project-hover">
            <h4>MeterMiser <br />Web App</h4>
            <ModalMeterMiser />
          </div>
        </div>
      </div>

      <div class="project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/dead-air2.jpg" />
          <div class="project-hover">
            <h4>"Dead Air" <br />Instant Empire <br />Music Video</h4>
            <ModalDeadAir />
          </div>
        </div>
      </div>

      <div class="project video-project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/lemongrass.jpg" />
          <div class="project-hover">
            <h4>Lemon Grass Kitchen Commercial</h4>
            <ModalLemonGrass />
          </div>
        </div>
      </div>

      <div class="project">
        <div class="project-content">
          <img src="../assets/images/featured-projects/luckys.jpg" />
          <div class="project-hover">
            <h4>Lucky's Market <br />Commercial</h4>
            <ModalLuckysMarket />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalRadioRecliner from "./Modals/ModalRadioRecliner";
import ModalCeramicDental from "./Modals/ModalCeramicDental";
import ModalAIE from "./Modals/ModalAIE";
import ModalSDP from "./Modals/ModalSDP";
import ModalMeterMiser from "./Modals/ModalMeterMiser";
import ModalCircuitStudios from "./Modals/ModalCircuitStudios";
import ModalGripWorks from "./Modals/ModalGripWorks";
import ModalDeadAir from "./Modals/ModalDeadAir";
import ModalLemonGrass from "./Modals/ModalLemonGrass";
import ModalLuckysMarket from "./Modals/ModalLuckysMarket";

export default {
  components: {
    ModalRadioRecliner,
    ModalCeramicDental,
    ModalSDP,
    ModalAIE,
    ModalCircuitStudios,
    ModalGripWorks,
    ModalMeterMiser,
    ModalDeadAir,
    ModalLemonGrass,
    ModalLuckysMarket,
  },
};
</script>

<style lang="scss">
#featured-projects {
  padding: 5rem 1rem;
  position: relative;

  .shadow-cont {
    box-shadow: 0 11px 10px -4px rgb(0 0 0 / 60%);
    position: absolute;
    top: -22px;
    left: 0;
    width: 100%;
    height: 22px;
  }

  .section-header {
    h2 {
      color: $mcf-blue;
      font-size: 2.5rem;
      line-height: 1.2;
      margin: 2rem 0 3rem;
    }
  }

  .projects-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    max-width: 1180px;
    margin: auto;
  }

  .project {
    display: inline-block;
    max-width: 500px;
    .project-content {
      box-shadow: -2px 4px 6px #000;
      overflow: hidden;
      position: relative;
      margin-bottom: 2.2rem;
      img {
        transform: scale(1);
        transition: all 0.5s ease 0s;
        max-width: 100%;
        height: auto;
        vertical-align: middle;
      }
      .project-hover,
      .project-hover:before {
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        opacity: 0;
      }
      .project-hover {
        padding: 30px;
        z-index: 1;
        transition: 0.6s;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        h4 {
          color: $white;
          font-weight: 600;
          font-family: "Montserrat", sans-serif;
          line-height: 1.2;
          font-size: 1.8rem;
          margin-bottom: 1rem;
        }
        &:before {
          content: "";
          background-color: #000;
          visibility: hidden;
          z-index: -1;
          transition: 0.4s;
        }
      }
      &:hover {
        img {
          transform: scale(1.25);
        }
        .project-hover {
          opacity: 1;
        }
        .project-hover:before {
          opacity: 0.7;
          visibility: visible;
        }
      }
    }
  }
}
#app-filter {
  .title-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .title {
    font-family: "Dawning of a New Day", cursive;
    font-size: 30pt;
    font-weight: normal;
  }

  .project-title {
    font-size: 16pt;
  }

  .filter {
    font-family: arial;
    padding: 6px 6px;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.35s;
  }

  .filter.active {
    box-shadow: 0px 1px 3px 0px #00000026;
  }

  .filter:hover {
    background: lightgray;
  }

  .projects {
    margin-top: 25px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .projects-enter {
    transform: scale(0.5) translatey(-80px);
    opacity: 0;
  }

  .projects-leave-to {
    transform: translatey(30px);
    opacity: 0;
  }

  .projects-leave-active {
    position: absolute;
    z-index: -1;
  }

  .circle {
    text-align: center;
    position: absolute;
    bottom: -38px;
    left: 40px;
    width: 100px;
    height: 100px;
    border-radius: 50px;
    /* 	border:1px solid black; */
    display: flex;
    box-shadow: 0px -4px 3px 0px #494d3257;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    /* 	box-shadow:0px -3px 3px #484848a6; */
  }

  .project {
    transition: all 0.35s ease-in-out;
    margin: 10px;
    box-shadow: 0px 2px 8px lightgrey;
    border-radius: 3px;
    width: 180px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .project-image-wrapper {
    position: relative;
  }

  .gradient-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 150px;
    opacity: 0.09;
    background: linear-gradient(
        to bottom,
        rgba(0, 210, 247, 0.65) 0%,
        rgba(0, 210, 247, 0.64) 1%,
        rgba(0, 0, 0, 0) 100%
      ),
      linear-gradient(
        to top,
        rgba(247, 0, 156, 0.65) 0%,
        rgba(247, 0, 156, 0.64) 1%,
        rgba(0, 0, 0, 0) 100%
      );
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  .project-image {
    width: 100%;
    height: 150px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
}
</style>